export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45')
];

export const server_loads = [];

export const dictionary = {
		"/(binoq)/(web)/(overview)": [17,[2,4,5],[3]],
		"/(binoq)/admin/users": [40,[2,12],[3]],
		"/(binoq)/assist/(location)": [41,[2,13,14],[3]],
		"/(binoq)/assist/(location)/activity": [42,[2,13,14],[3]],
		"/(binoq)/assist/install": [43,[15]],
		"/(binoq)/assist/settings": [44,[2,13,16],[3]],
		"/(binoq)/assist/settings/general": [45,[2,13,16],[3]],
		"/(binoq)/(web)/cleaning": [20,[2,4],[3]],
		"/(binoq)/(web)/compare": [21,[2,4],[3]],
		"/(binoq)/(web)/configurations": [22,[2,4],[3]],
		"/(binoq)/(web)/exports": [23,[2,4,6],[3]],
		"/(binoq)/(web)/improve": [24,[2,4,7],[3]],
		"/(binoq)/(web)/live-status": [25,[2,4],[3]],
		"/(binoq)/(web)/(overview)/location": [18,[2,4,5],[3]],
		"/(binoq)/(web)/location/[locationId]": [26,[2,4,8],[3]],
		"/(binoq)/(web)/location/[locationId]/cleaning": [27,[2,4,8],[3]],
		"/(binoq)/(web)/location/[locationId]/uptime": [28,[2,4,8],[3]],
		"/(binoq)/(web)/location/[locationId]/volume": [29,[2,4,8],[3]],
		"/(binoq)/(web)/(overview)/map": [19,[2,4,5],[3]],
		"/(binoq)/(web)/reports": [30,[2,4,9],[3]],
		"/(binoq)/(web)/reports/[reportTypeId]/schedules": [31,[2,4,9],[3]],
		"/(binoq)/(web)/uninstalled": [32,[2,4,10],[3]],
		"/(binoq)/(web)/upgrades": [33,[2,4,11],[3]],
		"/(binoq)/(web)/uptime": [34,[2,4],[3]],
		"/(binoq)/(web)/users": [38,[2,4],[3]],
		"/(binoq)/(web)/user": [35,[2,4],[3]],
		"/(binoq)/(web)/user/terms-of-use": [36,[2,4],[3]],
		"/(binoq)/(web)/user/terms-of-use/[versionNo]": [37,[2,4],[3]],
		"/(binoq)/(web)/volume": [39,[2,4],[3]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';